import React from "react";
import { TextInput, SelectMenu, List } from "@raketa-cms/raketa-cms";
import InputSection from "./InputSection";
import InputPopup from "./InputPopup";
import Currency from "../../../../helpers/Currency";
import TooltipInput from "./TooltipInput";

const DEFAULTS = {
  rate_plan_id: "",
  old_prices_tooltip: TooltipInput.defaults,
  promo_code: "",
  price_display_type: "per_month",
  after_price: "/month",
  qty: 1,
  old_prices: [],
  disable_upsell: "no",
  billed_timing_details: "",
};

const OldPriceInput = ({ value: prices, onChange }) => (
  <List
    label="Old prices"
    listItem={(settings, onChangeItem) => (
      <React.Fragment>
        <SelectMenu
          label="Currency"
          options={Currency.allInZuora.map((cur) => [cur, cur])}
          value={settings.currency}
          onChange={(value) => onChangeItem("currency", value)}
        />

        <TextInput
          label="Value"
          value={settings.value}
          onChange={(value) => onChangeItem("value", value)}
        />
      </React.Fragment>
    )}
    onChangeList={(_key, listValue) =>
      onChange(
        listValue.map((lv) => ({
          currency: lv.currency,
          value: lv.value,
        }))
      )
    }
    items={prices.map((price, idx) => ({
      id: idx,
      currency: price.currency,
      value: price.value,
    }))}
    template={{ price: { currency: "eur", value: "" } }}
    primaryField="currency"
  />
);

const RatePlanInput = ({ label, value, onChange }) => {
  return (
    <InputSection title={label}>
      <TextInput
        label="Rate Plan ID"
        value={value.rate_plan_id}
        onChange={(rate_plan_id) => onChange({ ...value, rate_plan_id })}
      />

      <TextInput
        label="Promo code"
        value={value.promo_code}
        onChange={(promo_code) => onChange({ ...value, promo_code })}
      />

      <SelectMenu
        label="Price display"
        options={[
          ["per_month", "Per month"],
          ["per_year", "Per year"],
          ["per_triennial", "Per 3 years"],
        ]}
        value={value.price_display_type}
        onChange={(price_display_type) =>
          onChange({ ...value, price_display_type })
        }
      />

      <TextInput
        label="After price"
        value={value.after_price}
        onChange={(after_price) => onChange({ ...value, after_price })}
      />

      <TextInput
        label="Quantity"
        value={value.qty}
        onChange={(qty) => onChange({ ...value, qty })}
      />

      <TextInput
        label="Billed timing details (override)"
        value={value.billed_timing_details}
        onChange={(billed_timing_details) =>
          onChange({ ...value, billed_timing_details })
        }
        hint="Supports tokens {{LICENSES_COUNT}} - number of licenses, {{PER_UNIT}} - calcualtes price based on quantity. Supports also {{PER_MONTH}}, {{PER_YEAR}} and {{PER_TRIENNIAL}} tokens."
      />

      <SelectMenu
        label="Disable upsell/cross sell"
        options={[
          ["yes", "Yes"],
          ["no", "No"],
        ]}
        value={value.disable_upsell}
        onChange={(disable_upsell) => onChange({ ...value, disable_upsell })}
      />

      <InputPopup label="Old prices">
        <OldPriceInput
          value={value.old_prices || []}
          onChange={(old_prices) => onChange({ ...value, old_prices })}
        />
      </InputPopup>

      <InputSection title="Old Price Tooltip">
        <TooltipInput
          label="Old Price Tooltip"
          value={value.old_prices_tooltip || {}}
          onChange={(old_prices_tooltip) =>
            onChange({ ...value, old_prices_tooltip })
          }
        />
      </InputSection>
    </InputSection>
  );
};

RatePlanInput.defaults = DEFAULTS;

export default RatePlanInput;
